import React, { useState, useEffect } from "react"
import styled from "@emotion/styled"
import { injectIntl, Link } from "gatsby-plugin-intl"
import { isBrowser } from "../../../context/ApolloContext"
import { useLocation } from "@reach/router"

const ChristmasGbpStickyBannerWrapper = styled.div`
  width: 100%;
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  position: relative;
  background: ${props => props.theme.saleColor.bgColor};
  color: ${props => props.theme.saleColor.textColor};
  // background: #ffed7d;
  // color: #000;
  overflow: hidden;
`

const LinkBox = styled(Link)`
  width: 100%;
  position: absolute;
  height: 100%;
  z-index: 1;
`

const LinkButtonTitle = styled.span`
  display: none;
`

const Container = styled.div`
  width: 100%;
  margin: 0px auto;
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  position: relative;
  padding: 10px 20px 8px;

  @media (max-width: 480px) {
    padding: 8px 15px;
  }
`

const MobileButton = styled(Link)`
  display: none;
  // color: ${props => props.theme.saleColor.textColor};
  color: #000;
  margin-left: 10px;

  @media (max-width: 600px) {
    display: inline-block;
  }
`

const TextBox = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  font-family: "Museo";
  font-weight: 400;
  font-size: 16px;
  line-height: 1.2;
  // color: ${props => props.theme.saleColor.textColor};
  color: #000;
  text-align: left;

  @media (max-width: 600px) {
    // width: 100%;
  }
`

const LeftText = styled.div`
  align-items: center;
  justify-content: center;
  position: relative;
  font-family: "Gotham";
  font-weight: bold;
  font-size: 21px;
  line-height: 1;

  @media (max-width: 480px) {
    font-size: 16px;
  }

  @media (max-width: 360px) {
    font-size: 14px;
  }
`

const RightText = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  font-family: "Gotham Book";
  font-weight: 500;
  font-size: 16px;
  line-height: 1;

  > span {
    font-size: 21px;
    font-family: "Gotham";
    font-weight: bold;
    // background: ${props => props.theme.colors.white.base};
    // color: ${props => props.theme.saleColor.textColor};
    // color: ${props => props.theme.saleColor.bgColor};
    // background: ${props => props.theme.saleColor.textColor};
    // color: ${props => props.theme.saleColor.bgColor};
    // background: #000;
    // color: #D7EDF6;
    // padding: 4px 8px;
    display: flex;
    align-items: center;
    // text-transform: uppercase;
    margin: 0px 7px;

    @media (max-width: 600px) {
      margin: 0px 5px;
    }

    @media (max-width: 480px) {
      font-size: 16px;
    }

    @media (max-width: 360px) {
      font-size: 14px;
    }
  }

  @media (max-width: 600px) {
    // font-size: 14px;
  }

  @media (max-width: 480px) {
    font-size: 14px;
  }
`

const Button = styled(Link)`
  // color: ${props => props.theme.saleColor.textColor};
  color: #000;
  font-size: 16px;
  font-family: "Gotham Book";
  font-weight: 500;
  margin-left: 25px;
  text-decoration: underline;
  line-height: 22px;
  display: inline-block;

  @media (max-width: 600px) {
    display: none;
  }

  :hover {
    // color: ${props => props.theme.saleColor.textColor};
    color: #000;
  }
`

const ChristmasGbpStickyBanner = ({ intl }) => {
  const [shopButtonHide, setShopButtonHide] = useState(false)
  const { pathname } = useLocation()

  const checkButtonVisibility = () => {
    let currentPath = ""
    let ButtonHide = false

    let regex = /(lyneup|lynefit|lynehome|loop)/
    currentPath = window.location.pathname

    ButtonHide = regex.test(currentPath)
    setShopButtonHide(ButtonHide)
  }

  useEffect(() => {
    isBrowser && checkButtonVisibility()
  }, [pathname])

  return (
    <ChristmasGbpStickyBannerWrapper className="LyneHomeStickyBanner">
      {shopButtonHide ? (
        <Container>
          <TextBox>
            {/* <LeftText>PERCKO DEALS</LeftText> */}
            <LeftText>Exclusive:</LeftText>
            <RightText>
              {/* <span>25% OFF</span> */}
              <span>20% off</span>
              <div>
                while supplies Last
                {/* 2<sup>nd</sup> top */}
              </div>
            </RightText>
          </TextBox>
        </Container>
      ) : (
        <Container>
          <LinkBox to="/shop/lyneup-test/">
            <LinkButtonTitle>{"Let's go >"}</LinkButtonTitle>
          </LinkBox>
          <TextBox>
            {/* <LeftText>PERCKO DEALS</LeftText> */}
            <LeftText>Exclusive:</LeftText>
            <RightText>
              {/* <span>25% OFF</span> */}
              <span>20% off</span>
              <div>
                while supplies Last
                {/* 2<sup>nd</sup> top */}
              </div>
            </RightText>
          </TextBox>
          <Button to="/shop/lyneup-test/">{"Let's go >"}</Button>
          <MobileButton to="/shop/lyneup-test/">{">"}</MobileButton>
        </Container>
      )}
    </ChristmasGbpStickyBannerWrapper>
  )
}

export default injectIntl(ChristmasGbpStickyBanner)
